import { escapeRegExp } from "lodash";
import { ReactNode } from "react";

import { isISODateStr } from "@ryde/shared";

import { decorateWithMark } from "../grid";

export const decorateGridValueWithSearch = (
  value: ReactNode,
  searchValue: string | undefined,
): ReactNode => {
  if (
    !searchValue?.length ||
    !value ||
    typeof value === "object" ||
    Array.isArray(value) ||
    isISODateStr(String(value))
  ) {
    return value;
  }

  let valueNormalized = value;

  if (typeof value === "number") {
    valueNormalized = value.toFixed();
  }

  if (
    String(valueNormalized)
      .toLowerCase()
      .match(escapeRegExp(searchValue).toLowerCase())
  ) {
    return decorateWithMark(String(valueNormalized), searchValue);
  }

  return value;
};
